/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { allServiceLinkedToAuthSupport } from '../fn/subscriptions/all-service-linked-to-auth-support';
import { AllServiceLinkedToAuthSupport$Params } from '../fn/subscriptions/all-service-linked-to-auth-support';
import { assignAuthSupportsToSubscription } from '../fn/subscriptions/assign-auth-supports-to-subscription';
import { AssignAuthSupportsToSubscription$Params } from '../fn/subscriptions/assign-auth-supports-to-subscription';
import { assignVehiclesToSubscription } from '../fn/subscriptions/assign-vehicles-to-subscription';
import { AssignVehiclesToSubscription$Params } from '../fn/subscriptions/assign-vehicles-to-subscription';
import { AuthSupportPagedList } from '../models/auth-support-paged-list';
import { changeSubscriptionState } from '../fn/subscriptions/change-subscription-state';
import { ChangeSubscriptionState$Params } from '../fn/subscriptions/change-subscription-state';
import { createSubscription } from '../fn/subscriptions/create-subscription';
import { CreateSubscription$Params } from '../fn/subscriptions/create-subscription';
import { createSubscriptionSubService } from '../fn/sub-services/create-subscription-sub-service';
import { CreateSubscriptionSubService$Params } from '../fn/sub-services/create-subscription-sub-service';
import { deletePlannedAuthSupportsTransferToSubscription } from '../fn/subscriptions/delete-planned-auth-supports-transfer-to-subscription';
import { DeletePlannedAuthSupportsTransferToSubscription$Params } from '../fn/subscriptions/delete-planned-auth-supports-transfer-to-subscription';
import { deleteSubscription } from '../fn/subscriptions/delete-subscription';
import { DeleteSubscription$Params } from '../fn/subscriptions/delete-subscription';
import { Error } from '../models/error';
import { exportStationsAndNetworksOfSubscription } from '../fn/subscriptions/export-stations-and-networks-of-subscription';
import { ExportStationsAndNetworksOfSubscription$Params } from '../fn/subscriptions/export-stations-and-networks-of-subscription';
import { exportSubscribedUsers } from '../fn/subscriptions/export-subscribed-users';
import { ExportSubscribedUsers$Params } from '../fn/subscriptions/export-subscribed-users';
import { exportSubscriptionAuthSupports } from '../fn/subscriptions/export-subscription-auth-supports';
import { ExportSubscriptionAuthSupports$Params } from '../fn/subscriptions/export-subscription-auth-supports';
import { exportSubscriptionTransactions } from '../fn/transactions/export-subscription-transactions';
import { ExportSubscriptionTransactions$Params } from '../fn/transactions/export-subscription-transactions';
import { exportSubscriptionVehicles } from '../fn/subscriptions/export-subscription-vehicles';
import { ExportSubscriptionVehicles$Params } from '../fn/subscriptions/export-subscription-vehicles';
import { getAllSubscriptionSubServices } from '../fn/sub-services/get-all-subscription-sub-services';
import { GetAllSubscriptionSubServices$Params } from '../fn/sub-services/get-all-subscription-sub-services';
import { getAllSubscriptionSubServicesSummaries } from '../fn/sub-services/get-all-subscription-sub-services-summaries';
import { GetAllSubscriptionSubServicesSummaries$Params } from '../fn/sub-services/get-all-subscription-sub-services-summaries';
import { getEffectiveStationsOfSubscription } from '../fn/subscriptions/get-effective-stations-of-subscription';
import { GetEffectiveStationsOfSubscription$Params } from '../fn/subscriptions/get-effective-stations-of-subscription';
import { getNetworksOfSubscription } from '../fn/subscriptions/get-networks-of-subscription';
import { GetNetworksOfSubscription$Params } from '../fn/subscriptions/get-networks-of-subscription';
import { getPlannedAuthSupportsTransfersToSubscription } from '../fn/subscriptions/get-planned-auth-supports-transfers-to-subscription';
import { GetPlannedAuthSupportsTransfersToSubscription$Params } from '../fn/subscriptions/get-planned-auth-supports-transfers-to-subscription';
import { getStationsOfSubscription } from '../fn/subscriptions/get-stations-of-subscription';
import { GetStationsOfSubscription$Params } from '../fn/subscriptions/get-stations-of-subscription';
import { getSubscription } from '../fn/subscriptions/get-subscription';
import { GetSubscription$Params } from '../fn/subscriptions/get-subscription';
import { getSubscriptionsAuthSupportStats } from '../fn/subscriptions/get-subscriptions-auth-support-stats';
import { GetSubscriptionsAuthSupportStats$Params } from '../fn/subscriptions/get-subscriptions-auth-support-stats';
import { getSubscriptionsChangesHistory } from '../fn/subscriptions/get-subscriptions-changes-history';
import { GetSubscriptionsChangesHistory$Params } from '../fn/subscriptions/get-subscriptions-changes-history';
import { getSubscriptionSubService } from '../fn/sub-services/get-subscription-sub-service';
import { GetSubscriptionSubService$Params } from '../fn/sub-services/get-subscription-sub-service';
import { getTransactionsOfSubscription } from '../fn/transactions/get-transactions-of-subscription';
import { GetTransactionsOfSubscription$Params } from '../fn/transactions/get-transactions-of-subscription';
import { getUserOfSubscription } from '../fn/subscriptions/get-user-of-subscription';
import { GetUserOfSubscription$Params } from '../fn/subscriptions/get-user-of-subscription';
import { getUsersOfSubscription } from '../fn/subscriptions/get-users-of-subscription';
import { GetUsersOfSubscription$Params } from '../fn/subscriptions/get-users-of-subscription';
import { getVehiclesOfSubscription } from '../fn/subscriptions/get-vehicles-of-subscription';
import { GetVehiclesOfSubscription$Params } from '../fn/subscriptions/get-vehicles-of-subscription';
import { importNewUsersToSubscribe } from '../fn/subscriptions/import-new-users-to-subscribe';
import { ImportNewUsersToSubscribe$Params } from '../fn/subscriptions/import-new-users-to-subscribe';
import { importStationsAndNetworksOfSubscription } from '../fn/subscriptions/import-stations-and-networks-of-subscription';
import { ImportStationsAndNetworksOfSubscription$Params } from '../fn/subscriptions/import-stations-and-networks-of-subscription';
import { importSubscriptionVehicles } from '../fn/subscriptions/import-subscription-vehicles';
import { ImportSubscriptionVehicles$Params } from '../fn/subscriptions/import-subscription-vehicles';
import { PlannedAuthSupportsTransferList } from '../models/planned-auth-supports-transfer-list';
import { removeAuthSupportsFromSubscription } from '../fn/subscriptions/remove-auth-supports-from-subscription';
import { RemoveAuthSupportsFromSubscription$Params } from '../fn/subscriptions/remove-auth-supports-from-subscription';
import { removeVehiclesToSubscription } from '../fn/subscriptions/remove-vehicles-to-subscription';
import { RemoveVehiclesToSubscription$Params } from '../fn/subscriptions/remove-vehicles-to-subscription';
import { searchAuthSupportsOfSubscription$Any } from '../fn/subscriptions/search-auth-supports-of-subscription-any';
import { SearchAuthSupportsOfSubscription$Any$Params } from '../fn/subscriptions/search-auth-supports-of-subscription-any';
import { searchAuthSupportsOfSubscription$Json } from '../fn/subscriptions/search-auth-supports-of-subscription-json';
import { SearchAuthSupportsOfSubscription$Json$Params } from '../fn/subscriptions/search-auth-supports-of-subscription-json';
import { searchSubscriptions$Any } from '../fn/subscriptions/search-subscriptions-any';
import { SearchSubscriptions$Any$Params } from '../fn/subscriptions/search-subscriptions-any';
import { searchSubscriptions$Json } from '../fn/subscriptions/search-subscriptions-json';
import { SearchSubscriptions$Json$Params } from '../fn/subscriptions/search-subscriptions-json';
import { searchSubServices } from '../fn/sub-services/search-sub-services';
import { SearchSubServices$Params } from '../fn/sub-services/search-sub-services';
import { searchTransactionsOfSubscription$Any } from '../fn/transactions/search-transactions-of-subscription-any';
import { SearchTransactionsOfSubscription$Any$Params } from '../fn/transactions/search-transactions-of-subscription-any';
import { searchTransactionsOfSubscription$Json } from '../fn/transactions/search-transactions-of-subscription-json';
import { SearchTransactionsOfSubscription$Json$Params } from '../fn/transactions/search-transactions-of-subscription-json';
import { setSubscriptionSubServiceActiveState } from '../fn/sub-services/set-subscription-sub-service-active-state';
import { SetSubscriptionSubServiceActiveState$Params } from '../fn/sub-services/set-subscription-sub-service-active-state';
import { StationPagedList } from '../models/station-paged-list';
import { subscribePartnersOperator } from '../fn/partners-operator/subscribe-partners-operator';
import { SubscribePartnersOperator$Params } from '../fn/partners-operator/subscribe-partners-operator';
import { subscribeUsersToSubscription } from '../fn/subscriptions/subscribe-users-to-subscription';
import { SubscribeUsersToSubscription$Params } from '../fn/subscriptions/subscribe-users-to-subscription';
import { Subscription } from '../models/subscription';
import { SubscriptionAuthSupportStats } from '../models/subscription-auth-support-stats';
import { SubscriptionHistoryPagedList } from '../models/subscription-history-paged-list';
import { SubscriptionNetworksPagedList } from '../models/subscription-networks-paged-list';
import { SubscriptionPagedList } from '../models/subscription-paged-list';
import { SubscriptionStationsPagedList } from '../models/subscription-stations-paged-list';
import { SubscriptionSubService } from '../models/subscription-sub-service';
import { SubscriptionSubServiceList } from '../models/subscription-sub-service-list';
import { SubscriptionSubServicePagedList } from '../models/subscription-sub-service-paged-list';
import { SubscriptionSubServiceSummaryList } from '../models/subscription-sub-service-summary-list';
import { SubscriptionUser } from '../models/subscription-user';
import { SubscriptionUsersPagedList } from '../models/subscription-users-paged-list';
import { TransactionPagedList } from '../models/transaction-paged-list';
import { transferAuthSupportsToSubscription } from '../fn/subscriptions/transfer-auth-supports-to-subscription';
import { TransferAuthSupportsToSubscription$Params } from '../fn/subscriptions/transfer-auth-supports-to-subscription';
import { unsubscribeUsersFromSubscription } from '../fn/subscriptions/unsubscribe-users-from-subscription';
import { UnsubscribeUsersFromSubscription$Params } from '../fn/subscriptions/unsubscribe-users-from-subscription';
import { updateSubscription } from '../fn/subscriptions/update-subscription';
import { UpdateSubscription$Params } from '../fn/subscriptions/update-subscription';
import { updateSubscriptionSubService } from '../fn/sub-services/update-subscription-sub-service';
import { UpdateSubscriptionSubService$Params } from '../fn/sub-services/update-subscription-sub-service';
import { userAddAuthSupports } from '../fn/subscriptions/user-add-auth-supports';
import { UserAddAuthSupports$Params } from '../fn/subscriptions/user-add-auth-supports';
import { userAddVehicles } from '../fn/subscriptions/user-add-vehicles';
import { UserAddVehicles$Params } from '../fn/subscriptions/user-add-vehicles';
import { userRemoveAuthSupports } from '../fn/subscriptions/user-remove-auth-supports';
import { UserRemoveAuthSupports$Params } from '../fn/subscriptions/user-remove-auth-supports';
import { userRemoveVehicles } from '../fn/subscriptions/user-remove-vehicles';
import { UserRemoveVehicles$Params } from '../fn/subscriptions/user-remove-vehicles';
import { vehicleAddAuthSupport } from '../fn/subscriptions/vehicle-add-auth-support';
import { VehicleAddAuthSupport$Params } from '../fn/subscriptions/vehicle-add-auth-support';
import { VehiclePagedList } from '../models/vehicle-paged-list';
import { vehicleRemoveAuthSupport } from '../fn/subscriptions/vehicle-remove-auth-support';
import { VehicleRemoveAuthSupport$Params } from '../fn/subscriptions/vehicle-remove-auth-support';


/**
 * All about the subscriptions
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionsService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchSubscriptions()` */
  static readonly SearchSubscriptionsPath = '/subscriptions/search';

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSubscriptions$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubscriptions$Json$Response(params?: SearchSubscriptions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPagedList>> {
    return searchSubscriptions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSubscriptions$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubscriptions$Json(params?: SearchSubscriptions$Json$Params, context?: HttpContext): Observable<SubscriptionPagedList> {
    return this.searchSubscriptions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionPagedList>): SubscriptionPagedList => r.body)
    );
  }

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSubscriptions$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchSubscriptions$Any$Response(params?: SearchSubscriptions$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPagedList>> {
    return searchSubscriptions$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSubscriptions$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchSubscriptions$Any(params?: SearchSubscriptions$Any$Params, context?: HttpContext): Observable<SubscriptionPagedList> {
    return this.searchSubscriptions$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionPagedList>): SubscriptionPagedList => r.body)
    );
  }

  /** Path part for operation `createSubscription()` */
  static readonly CreateSubscriptionPath = '/subscriptions';

  /**
   * Create a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscription$Response(params: CreateSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscription(params: CreateSubscription$Params, context?: HttpContext): Observable<void> {
    return this.createSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubscription()` */
  static readonly GetSubscriptionPath = '/subscriptions/{uid}';

  /**
   * Get a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscription$Response(params: GetSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<Subscription>> {
    return getSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscription(params: GetSubscription$Params, context?: HttpContext): Observable<Subscription> {
    return this.getSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<Subscription>): Subscription => r.body)
    );
  }

  /** Path part for operation `updateSubscription()` */
  static readonly UpdateSubscriptionPath = '/subscriptions/{uid}';

  /**
   * Update a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscription$Response(params: UpdateSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscription(params: UpdateSubscription$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSubscription()` */
  static readonly DeleteSubscriptionPath = '/subscriptions/{uid}';

  /**
   * Delete a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscription$Response(params: DeleteSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscription(params: DeleteSubscription$Params, context?: HttpContext): Observable<void> {
    return this.deleteSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubscriptionsChangesHistory()` */
  static readonly GetSubscriptionsChangesHistoryPath = '/subscriptions/{uid}/history';

  /**
   * Retrieve a list of change made to a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionsChangesHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionsChangesHistory$Response(params: GetSubscriptionsChangesHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionHistoryPagedList>> {
    return getSubscriptionsChangesHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of change made to a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionsChangesHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionsChangesHistory(params: GetSubscriptionsChangesHistory$Params, context?: HttpContext): Observable<SubscriptionHistoryPagedList> {
    return this.getSubscriptionsChangesHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionHistoryPagedList>): SubscriptionHistoryPagedList => r.body)
    );
  }

  /** Path part for operation `changeSubscriptionState()` */
  static readonly ChangeSubscriptionStatePath = '/subscriptions/{uid}/state';

  /**
   * Change the state of a subscription directly or plan it.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeSubscriptionState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeSubscriptionState$Response(params: ChangeSubscriptionState$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeSubscriptionState(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the state of a subscription directly or plan it.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeSubscriptionState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeSubscriptionState(params: ChangeSubscriptionState$Params, context?: HttpContext): Observable<void> {
    return this.changeSubscriptionState$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubscriptionsAuthSupportStats()` */
  static readonly GetSubscriptionsAuthSupportStatsPath = '/subscriptions/auth-supports/stats';

  /**
   * Get stats about subscriptions auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionsAuthSupportStats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportStats$Response(params: GetSubscriptionsAuthSupportStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionAuthSupportStats>>> {
    return getSubscriptionsAuthSupportStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get stats about subscriptions auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionsAuthSupportStats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportStats(params: GetSubscriptionsAuthSupportStats$Params, context?: HttpContext): Observable<Array<SubscriptionAuthSupportStats>> {
    return this.getSubscriptionsAuthSupportStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubscriptionAuthSupportStats>>): Array<SubscriptionAuthSupportStats> => r.body)
    );
  }

  /** Path part for operation `searchAuthSupportsOfSubscription()` */
  static readonly SearchAuthSupportsOfSubscriptionPath = '/subscriptions/{uid}/auth-supports/search';

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAuthSupportsOfSubscription$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAuthSupportsOfSubscription$Json$Response(params: SearchAuthSupportsOfSubscription$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return searchAuthSupportsOfSubscription$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAuthSupportsOfSubscription$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAuthSupportsOfSubscription$Json(params: SearchAuthSupportsOfSubscription$Json$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.searchAuthSupportsOfSubscription$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAuthSupportsOfSubscription$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAuthSupportsOfSubscription$Any$Response(params: SearchAuthSupportsOfSubscription$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return searchAuthSupportsOfSubscription$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * List the auth supports of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAuthSupportsOfSubscription$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchAuthSupportsOfSubscription$Any(params: SearchAuthSupportsOfSubscription$Any$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.searchAuthSupportsOfSubscription$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionAuthSupports()` */
  static readonly ExportSubscriptionAuthSupportsPath = '/subscriptions/{uid}/auth-supports/export';

  /**
   * Export  the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionAuthSupports()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupports$Response(params: ExportSubscriptionAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionAuthSupports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupports(params: ExportSubscriptionAuthSupports$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `assignAuthSupportsToSubscription()` */
  static readonly AssignAuthSupportsToSubscriptionPath = '/subscriptions/{uid}/auth-supports/assign';

  /**
   * Add auth supports to a subscription, if the supports are already assigned to a subscription, they will be ignored.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignAuthSupportsToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscription$Response(params: AssignAuthSupportsToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignAuthSupportsToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Add auth supports to a subscription, if the supports are already assigned to a subscription, they will be ignored.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignAuthSupportsToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscription(params: AssignAuthSupportsToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.assignAuthSupportsToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeAuthSupportsFromSubscription()` */
  static readonly RemoveAuthSupportsFromSubscriptionPath = '/subscriptions/{uid}/auth-supports/remove';

  /**
   * Remove auth supports from a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeAuthSupportsFromSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeAuthSupportsFromSubscription$Response(params: RemoveAuthSupportsFromSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeAuthSupportsFromSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove auth supports from a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeAuthSupportsFromSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeAuthSupportsFromSubscription(params: RemoveAuthSupportsFromSubscription$Params, context?: HttpContext): Observable<void> {
    return this.removeAuthSupportsFromSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `transferAuthSupportsToSubscription()` */
  static readonly TransferAuthSupportsToSubscriptionPath = '/subscriptions/{uid}/auth-supports/transfer';

  /**
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint, already assigned supports will be removed from any link they have to be assigned to the new subscription. So use this endpoint with caution.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferAuthSupportsToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscription$Response(params: TransferAuthSupportsToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return transferAuthSupportsToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint, already assigned supports will be removed from any link they have to be assigned to the new subscription. So use this endpoint with caution.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transferAuthSupportsToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscription(params: TransferAuthSupportsToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.transferAuthSupportsToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPlannedAuthSupportsTransfersToSubscription()` */
  static readonly GetPlannedAuthSupportsTransfersToSubscriptionPath = '/subscriptions/{uid}/auth-supports/transfer/planned';

  /**
   * Get the planned transfers of auth-supports to the subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlannedAuthSupportsTransfersToSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedAuthSupportsTransfersToSubscription$Response(params: GetPlannedAuthSupportsTransfersToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedAuthSupportsTransferList>> {
    return getPlannedAuthSupportsTransfersToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the planned transfers of auth-supports to the subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlannedAuthSupportsTransfersToSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedAuthSupportsTransfersToSubscription(params: GetPlannedAuthSupportsTransfersToSubscription$Params, context?: HttpContext): Observable<PlannedAuthSupportsTransferList> {
    return this.getPlannedAuthSupportsTransfersToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedAuthSupportsTransferList>): PlannedAuthSupportsTransferList => r.body)
    );
  }

  /** Path part for operation `deletePlannedAuthSupportsTransferToSubscription()` */
  static readonly DeletePlannedAuthSupportsTransferToSubscriptionPath = '/subscriptions/{uid}/auth-supports/transfer/planned/{transferUid}';

  /**
   * Delete a planned transfer of auth-supports to the subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePlannedAuthSupportsTransferToSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedAuthSupportsTransferToSubscription$Response(params: DeletePlannedAuthSupportsTransferToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePlannedAuthSupportsTransferToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a planned transfer of auth-supports to the subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePlannedAuthSupportsTransferToSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedAuthSupportsTransferToSubscription(params: DeletePlannedAuthSupportsTransferToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.deletePlannedAuthSupportsTransferToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfSubscription()` */
  static readonly GetTransactionsOfSubscriptionPath = '/subscriptions/{uid}/transactions';

  /**
   * Search the transactions of a subscription without filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfSubscription$Response(params: GetTransactionsOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription without filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getTransactionsOfSubscription(params: GetTransactionsOfSubscription$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `searchTransactionsOfSubscription()` */
  static readonly SearchTransactionsOfSubscriptionPath = '/subscriptions/{uid}/transactions/search';

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfSubscription$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfSubscription$Json$Response(params: SearchTransactionsOfSubscription$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfSubscription$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfSubscription$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTransactionsOfSubscription$Json(params: SearchTransactionsOfSubscription$Json$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfSubscription$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTransactionsOfSubscription$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfSubscription$Any$Response(params: SearchTransactionsOfSubscription$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return searchTransactionsOfSubscription$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription with filters, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTransactionsOfSubscription$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTransactionsOfSubscription$Any(params: SearchTransactionsOfSubscription$Any$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.searchTransactionsOfSubscription$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionTransactions()` */
  static readonly ExportSubscriptionTransactionsPath = '/subscriptions/{uid}/transactions/export';

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactions$Response(params: ExportSubscriptionTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactions(params: ExportSubscriptionTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getEffectiveStationsOfSubscription()` */
  static readonly GetEffectiveStationsOfSubscriptionPath = '/subscriptions/{uid}/effective/stations';

  /**
   * Retrieve a list of stations of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEffectiveStationsOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveStationsOfSubscription$Response(params: GetEffectiveStationsOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<StationPagedList>> {
    return getEffectiveStationsOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of stations of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEffectiveStationsOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveStationsOfSubscription(params: GetEffectiveStationsOfSubscription$Params, context?: HttpContext): Observable<StationPagedList> {
    return this.getEffectiveStationsOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationPagedList>): StationPagedList => r.body)
    );
  }

  /** Path part for operation `getStationsOfSubscription()` */
  static readonly GetStationsOfSubscriptionPath = '/subscriptions/{uid}/stations';

  /**
   * Retrieve a list of stations of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationsOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationsOfSubscription$Response(params: GetStationsOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionStationsPagedList>> {
    return getStationsOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of stations of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationsOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationsOfSubscription(params: GetStationsOfSubscription$Params, context?: HttpContext): Observable<SubscriptionStationsPagedList> {
    return this.getStationsOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionStationsPagedList>): SubscriptionStationsPagedList => r.body)
    );
  }

  /** Path part for operation `getNetworksOfSubscription()` */
  static readonly GetNetworksOfSubscriptionPath = '/subscriptions/{uid}/networks';

  /**
   * Retrieve a list of networks of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNetworksOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNetworksOfSubscription$Response(params: GetNetworksOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionNetworksPagedList>> {
    return getNetworksOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of networks of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNetworksOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNetworksOfSubscription(params: GetNetworksOfSubscription$Params, context?: HttpContext): Observable<SubscriptionNetworksPagedList> {
    return this.getNetworksOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionNetworksPagedList>): SubscriptionNetworksPagedList => r.body)
    );
  }

  /** Path part for operation `exportStationsAndNetworksOfSubscription()` */
  static readonly ExportStationsAndNetworksOfSubscriptionPath = '/subscriptions/{uid}/stations-networks/export';

  /**
   * Export the stations and networks that can be linked to this subscription and the current links.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationsAndNetworksOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationsAndNetworksOfSubscription$Response(params: ExportStationsAndNetworksOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationsAndNetworksOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the stations and networks that can be linked to this subscription and the current links.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationsAndNetworksOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationsAndNetworksOfSubscription(params: ExportStationsAndNetworksOfSubscription$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationsAndNetworksOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importStationsAndNetworksOfSubscription()` */
  static readonly ImportStationsAndNetworksOfSubscriptionPath = '/subscriptions/{uid}/stations-networks/import';

  /**
   * Change the stations and networks links to this subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importStationsAndNetworksOfSubscription()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationsAndNetworksOfSubscription$Response(params: ImportStationsAndNetworksOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importStationsAndNetworksOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the stations and networks links to this subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importStationsAndNetworksOfSubscription$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationsAndNetworksOfSubscription(params: ImportStationsAndNetworksOfSubscription$Params, context?: HttpContext): Observable<void> {
    return this.importStationsAndNetworksOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscribeUsersToSubscription()` */
  static readonly SubscribeUsersToSubscriptionPath = '/subscriptions/{uid}/users/subscribe';

  /**
   * Subscribe user to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeUsersToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeUsersToSubscription$Response(params: SubscribeUsersToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribeUsersToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Subscribe user to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeUsersToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeUsersToSubscription(params: SubscribeUsersToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.subscribeUsersToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `unsubscribeUsersFromSubscription()` */
  static readonly UnsubscribeUsersFromSubscriptionPath = '/subscriptions/{uid}/users/unsubscribe';

  /**
   * Unsubscribe user from plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unsubscribeUsersFromSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  unsubscribeUsersFromSubscription$Response(params: UnsubscribeUsersFromSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unsubscribeUsersFromSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Unsubscribe user from plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unsubscribeUsersFromSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  unsubscribeUsersFromSubscription(params: UnsubscribeUsersFromSubscription$Params, context?: HttpContext): Observable<void> {
    return this.unsubscribeUsersFromSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUsersOfSubscription()` */
  static readonly GetUsersOfSubscriptionPath = '/subscriptions/{uid}/users';

  /**
   * Retrieve a list of service customers of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersOfSubscription$Response(params: GetUsersOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionUsersPagedList>> {
    return getUsersOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of service customers of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersOfSubscription(params: GetUsersOfSubscription$Params, context?: HttpContext): Observable<SubscriptionUsersPagedList> {
    return this.getUsersOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionUsersPagedList>): SubscriptionUsersPagedList => r.body)
    );
  }

  /** Path part for operation `getUserOfSubscription()` */
  static readonly GetUserOfSubscriptionPath = '/subscriptions/{uid}/users/{userUid}';

  /**
   * Retrieve an user of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOfSubscription$Response(params: GetUserOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionUser>> {
    return getUserOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve an user of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOfSubscription(params: GetUserOfSubscription$Params, context?: HttpContext): Observable<SubscriptionUser> {
    return this.getUserOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionUser>): SubscriptionUser => r.body)
    );
  }

  /** Path part for operation `exportSubscribedUsers()` */
  static readonly ExportSubscribedUsersPath = '/subscriptions/{uid}/users/export';

  /**
   * Export  the contacts and auth supports assigned to this subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscribedUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscribedUsers$Response(params: ExportSubscribedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscribedUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the contacts and auth supports assigned to this subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscribedUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscribedUsers(params: ExportSubscribedUsers$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscribedUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importNewUsersToSubscribe()` */
  static readonly ImportNewUsersToSubscribePath = '/subscriptions/{uid}/users/import';

  /**
   * Import the contacts and auth supports to add to a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importNewUsersToSubscribe()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importNewUsersToSubscribe$Response(params: ImportNewUsersToSubscribe$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importNewUsersToSubscribe(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the contacts and auth supports to add to a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importNewUsersToSubscribe$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importNewUsersToSubscribe(params: ImportNewUsersToSubscribe$Params, context?: HttpContext): Observable<void> {
    return this.importNewUsersToSubscribe$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userAddAuthSupports()` */
  static readonly UserAddAuthSupportsPath = '/subscriptions/{uid}/users/{userUid}/auth-supports/assign';

  /**
   * Add auth supports to a subscription and user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAddAuthSupports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddAuthSupports$Response(params: UserAddAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userAddAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Add auth supports to a subscription and user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAddAuthSupports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddAuthSupports(params: UserAddAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.userAddAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userRemoveAuthSupports()` */
  static readonly UserRemoveAuthSupportsPath = '/subscriptions/{uid}/users/{userUid}/auth-supports/remove';

  /**
   * Remove auth supports from a subscription and user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRemoveAuthSupports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveAuthSupports$Response(params: UserRemoveAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userRemoveAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove auth supports from a subscription and user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRemoveAuthSupports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveAuthSupports(params: UserRemoveAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.userRemoveAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userAddVehicles()` */
  static readonly UserAddVehiclesPath = '/subscriptions/{uid}/users/{userUid}/vehicles/assign';

  /**
   * Add vehicles to a subscription and an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAddVehicles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddVehicles$Response(params: UserAddVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userAddVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Add vehicles to a subscription and an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAddVehicles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddVehicles(params: UserAddVehicles$Params, context?: HttpContext): Observable<void> {
    return this.userAddVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userRemoveVehicles()` */
  static readonly UserRemoveVehiclesPath = '/subscriptions/{uid}/users/{userUid}/vehicles/remove';

  /**
   * Remove vehicles from a subscription and an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRemoveVehicles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveVehicles$Response(params: UserRemoveVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userRemoveVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove vehicles from a subscription and an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRemoveVehicles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveVehicles(params: UserRemoveVehicles$Params, context?: HttpContext): Observable<void> {
    return this.userRemoveVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVehiclesOfSubscription()` */
  static readonly GetVehiclesOfSubscriptionPath = '/subscriptions/{uid}/vehicles';

  /**
   * Retrieve a list of vehicles of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVehiclesOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehiclesOfSubscription$Response(params: GetVehiclesOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<VehiclePagedList>> {
    return getVehiclesOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of vehicles of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVehiclesOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehiclesOfSubscription(params: GetVehiclesOfSubscription$Params, context?: HttpContext): Observable<VehiclePagedList> {
    return this.getVehiclesOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<VehiclePagedList>): VehiclePagedList => r.body)
    );
  }

  /** Path part for operation `assignVehiclesToSubscription()` */
  static readonly AssignVehiclesToSubscriptionPath = '/subscriptions/{uid}/vehicles/assign';

  /**
   * Assign vehicle to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignVehiclesToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignVehiclesToSubscription$Response(params: AssignVehiclesToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignVehiclesToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign vehicle to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignVehiclesToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignVehiclesToSubscription(params: AssignVehiclesToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.assignVehiclesToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeVehiclesToSubscription()` */
  static readonly RemoveVehiclesToSubscriptionPath = '/subscriptions/{uid}/vehicles/remove';

  /**
   * Remove vehicles from plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeVehiclesToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeVehiclesToSubscription$Response(params: RemoveVehiclesToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeVehiclesToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove vehicles from plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeVehiclesToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeVehiclesToSubscription(params: RemoveVehiclesToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.removeVehiclesToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionVehicles()` */
  static readonly ExportSubscriptionVehiclesPath = '/subscriptions/{uid}/vehicles/export';

  /**
   * Export the vehicles and auth supports of a subscription.
   *
   * Allows to export the Subscription vehicles and auth supports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionVehicles()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionVehicles$Response(params: ExportSubscriptionVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the vehicles and auth supports of a subscription.
   *
   * Allows to export the Subscription vehicles and auth supports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionVehicles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionVehicles(params: ExportSubscriptionVehicles$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importSubscriptionVehicles()` */
  static readonly ImportSubscriptionVehiclesPath = '/subscriptions/{uid}/vehicles/import';

  /**
   * Import the vehicles and auth supports of a subscription.
   *
   * Allows to import the vehicles and auth supports of a subscription plan, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importSubscriptionVehicles()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importSubscriptionVehicles$Response(params: ImportSubscriptionVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importSubscriptionVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the vehicles and auth supports of a subscription.
   *
   * Allows to import the vehicles and auth supports of a subscription plan, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importSubscriptionVehicles$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importSubscriptionVehicles(params: ImportSubscriptionVehicles$Params, context?: HttpContext): Observable<void> {
    return this.importSubscriptionVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleAddAuthSupport()` */
  static readonly VehicleAddAuthSupportPath = '/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/assign';

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleAddAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupport$Response(params: VehicleAddAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleAddAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a auth support to a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleAddAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleAddAuthSupport(params: VehicleAddAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.vehicleAddAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vehicleRemoveAuthSupport()` */
  static readonly VehicleRemoveAuthSupportPath = '/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/remove';

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleRemoveAuthSupport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupport$Response(params: VehicleRemoveAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vehicleRemoveAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a auth support from a subscription and vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleRemoveAuthSupport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vehicleRemoveAuthSupport(params: VehicleRemoveAuthSupport$Params, context?: HttpContext): Observable<void> {
    return this.vehicleRemoveAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `allServiceLinkedToAuthSupport()` */
  static readonly AllServiceLinkedToAuthSupportPath = '/subscriptions/{uid}/sub-service/linked';

  /**
   * All service linked to an auth support.
   *
   * All service linked to an auth support
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allServiceLinkedToAuthSupport()` instead.
   *
   * This method doesn't expect any request body.
   */
  allServiceLinkedToAuthSupport$Response(params: AllServiceLinkedToAuthSupport$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServiceList>> {
    return allServiceLinkedToAuthSupport(this.http, this.rootUrl, params, context);
  }

  /**
   * All service linked to an auth support.
   *
   * All service linked to an auth support
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allServiceLinkedToAuthSupport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allServiceLinkedToAuthSupport(params: AllServiceLinkedToAuthSupport$Params, context?: HttpContext): Observable<SubscriptionSubServiceList> {
    return this.allServiceLinkedToAuthSupport$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServiceList>): SubscriptionSubServiceList => r.body)
    );
  }

  /** Path part for operation `getAllSubscriptionSubServices()` */
  static readonly GetAllSubscriptionSubServicesPath = '/subscriptions/{uid}/sub-service';

  /**
   * Get all sub services of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubscriptionSubServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServices$Response(params: GetAllSubscriptionSubServices$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServiceList>> {
    return getAllSubscriptionSubServices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all sub services of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSubscriptionSubServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServices(params: GetAllSubscriptionSubServices$Params, context?: HttpContext): Observable<SubscriptionSubServiceList> {
    return this.getAllSubscriptionSubServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServiceList>): SubscriptionSubServiceList => r.body)
    );
  }

  /** Path part for operation `createSubscriptionSubService()` */
  static readonly CreateSubscriptionSubServicePath = '/subscriptions/{uid}/sub-service';

  /**
   * Create a subscription sub service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscriptionSubService()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionSubService$Response(params: CreateSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSubscriptionSubService(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a subscription sub service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubscriptionSubService$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionSubService(params: CreateSubscriptionSubService$Params, context?: HttpContext): Observable<void> {
    return this.createSubscriptionSubService$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllSubscriptionSubServicesSummaries()` */
  static readonly GetAllSubscriptionSubServicesSummariesPath = '/subscriptions/{uid}/sub-service/summary';

  /**
   * Get all sub services summaries of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubscriptionSubServicesSummaries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServicesSummaries$Response(params: GetAllSubscriptionSubServicesSummaries$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServiceSummaryList>> {
    return getAllSubscriptionSubServicesSummaries(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all sub services summaries of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSubscriptionSubServicesSummaries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptionSubServicesSummaries(params: GetAllSubscriptionSubServicesSummaries$Params, context?: HttpContext): Observable<SubscriptionSubServiceSummaryList> {
    return this.getAllSubscriptionSubServicesSummaries$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServiceSummaryList>): SubscriptionSubServiceSummaryList => r.body)
    );
  }

  /** Path part for operation `getSubscriptionSubService()` */
  static readonly GetSubscriptionSubServicePath = '/subscriptions/{uid}/sub-service/{serviceUid}';

  /**
   * Get a subscription sub service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionSubService()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSubService$Response(params: GetSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubService>> {
    return getSubscriptionSubService(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a subscription sub service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionSubService$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionSubService(params: GetSubscriptionSubService$Params, context?: HttpContext): Observable<SubscriptionSubService> {
    return this.getSubscriptionSubService$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubService>): SubscriptionSubService => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionSubService()` */
  static readonly UpdateSubscriptionSubServicePath = '/subscriptions/{uid}/sub-service/{serviceUid}';

  /**
   * Update a subscription sub service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionSubService()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionSubService$Response(params: UpdateSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionSubService(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a subscription sub service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionSubService$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionSubService(params: UpdateSubscriptionSubService$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionSubService$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setSubscriptionSubServiceActiveState()` */
  static readonly SetSubscriptionSubServiceActiveStatePath = '/subscriptions/{uid}/sub-service/{serviceUid}/activation';

  /**
   * Change a subscription sub service active state.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setSubscriptionSubServiceActiveState()` instead.
   *
   * This method doesn't expect any request body.
   */
  setSubscriptionSubServiceActiveState$Response(params: SetSubscriptionSubServiceActiveState$Params, context?: HttpContext): Observable<StrictHttpResponse<Error>> {
    return setSubscriptionSubServiceActiveState(this.http, this.rootUrl, params, context);
  }

  /**
   * Change a subscription sub service active state.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setSubscriptionSubServiceActiveState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setSubscriptionSubServiceActiveState(params: SetSubscriptionSubServiceActiveState$Params, context?: HttpContext): Observable<Error> {
    return this.setSubscriptionSubServiceActiveState$Response(params, context).pipe(
      map((r: StrictHttpResponse<Error>): Error => r.body)
    );
  }

  /** Path part for operation `searchSubServices()` */
  static readonly SearchSubServicesPath = '/sub-service/search';

  /**
   * Search sub-services.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSubServices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubServices$Response(params?: SearchSubServices$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServicePagedList>> {
    return searchSubServices(this.http, this.rootUrl, params, context);
  }

  /**
   * Search sub-services.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSubServices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubServices(params?: SearchSubServices$Params, context?: HttpContext): Observable<SubscriptionSubServicePagedList> {
    return this.searchSubServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionSubServicePagedList>): SubscriptionSubServicePagedList => r.body)
    );
  }

  /** Path part for operation `subscribePartnersOperator()` */
  static readonly SubscribePartnersOperatorPath = '/partners/operator/{countryCode}/{partyId}/subscribe/{subscriptionUid}';

  /**
   * Subscribe partner operator credentials role to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribePartnersOperator()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribePartnersOperator$Response(params: SubscribePartnersOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribePartnersOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Subscribe partner operator credentials role to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribePartnersOperator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribePartnersOperator(params: SubscribePartnersOperator$Params, context?: HttpContext): Observable<void> {
    return this.subscribePartnersOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
